export default __webpack_public_path__ + "static/media/vard.5693249f.jpeg";